import {
  DatePicker,
  DatePickerProps,
  PickerValidDate,
} from "@mui/x-date-pickers";

const MuiDatePicker = (
  props: DatePickerProps<any> & React.RefAttributes<HTMLDivElement>
) => {
  const { ...rest } = props;

  return <DatePicker format="YYYY-MM-DD" {...rest} />;
};

export default MuiDatePicker;
